var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "61",
        height: "60",
        viewBox: "0 0 61 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M24.9397 34.7965C22.2352 32.0919 22.2352 27.7069 24.9397 25.0024C27.6443 22.2978 32.0293 22.2978 34.7338 25.0024C37.4384 27.7069 37.4384 32.0919 34.7338 34.7965C32.0293 37.501 27.6443 37.501 24.9397 34.7965Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M42.8166 42.7957C35.5938 50.0185 23.8831 50.0186 16.6602 42.7959C9.43718 35.5732 9.43708 23.8627 16.6599 16.6399C23.8828 9.41703 35.5934 9.41693 42.8164 16.6396C50.0394 23.8624 50.0395 35.5728 42.8166 42.7957ZM32.6542 32.6036C31.0491 34.2087 28.4467 34.2087 26.8416 32.6037C25.2365 30.9986 25.2365 28.3963 26.8416 26.7912C28.4466 25.1862 31.049 25.1861 32.6541 26.7912C34.2592 28.3962 34.2592 30.9986 32.6542 32.6036Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M24.9397 34.7965C22.2352 32.0919 22.2352 27.7069 24.9397 25.0024C27.6443 22.2978 32.0293 22.2978 34.7338 25.0024C37.4384 27.7069 37.4384 32.0919 34.7338 34.7965C32.0293 37.501 27.6443 37.501 24.9397 34.7965Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M42.8166 42.7957C35.5938 50.0185 23.8831 50.0186 16.6602 42.7959C9.43718 35.5732 9.43708 23.8627 16.6599 16.6399C23.8828 9.41703 35.5934 9.41693 42.8164 16.6396C50.0394 23.8624 50.0395 35.5728 42.8166 42.7957ZM32.6542 32.6036C31.0491 34.2087 28.4467 34.2087 26.8416 32.6037C25.2365 30.9986 25.2365 28.3963 26.8416 26.7912C28.4466 25.1862 31.049 25.1861 32.6541 26.7912C34.2592 28.3962 34.2592 30.9986 32.6542 32.6036Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M33.9238 52.4365H25.4844V7.00273H33.9238V52.4365Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M6.98633 33.9385L6.98633 25.4991L52.4201 25.4991L52.4201 33.9385L6.98633 33.9385Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16.623 48.7676L10.6555 42.8L42.782 10.6735L48.7496 16.641L16.623 48.7676Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M10.6562 16.6387L16.6238 10.6711L48.7504 42.7977L42.7828 48.7652L10.6562 16.6387Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M33.1369 29.4947H26.1699L27.3311 26.9402V20.6699H31.9757V26.9402L33.1369 29.4947Z",
          fill: "white"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M33.4614 29.2188H25.9499L21.5098 36.5755L23.4345 39.0924H36.167L37.7956 36.5755L33.4614 29.2188Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M26.1086 19.3125H33.2766V26.7487L39.1244 36.7636L36.7786 40.2172H22.6873L20.1621 36.7855L26.1086 26.7449V19.3125ZM28.3586 21.5625V27.3612L22.8567 36.6511L23.8252 37.9672H35.587L36.466 36.673L31.0266 27.3575V21.5625H28.3586Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }